import React from 'react';
import './fullPhotoArchive.css';
import img1 from '../../assets/img/libro/img1.jpg';
import img2 from '../../assets/img/libro/img2.jpg';
// importa aquí todas las demás imágenes hasta img40

const photos = [
  { src: img1, alt: 'Archivo 1', text: 'Texto 1' },
  { src: img2, alt: 'Archivo 2', text: 'Texto 2' },
  { src: img1, alt: 'Archivo 3', text: 'Texto 3' },
  { src: img2, alt: 'Archivo 4', text: 'Texto 4' },
  { src: img1, alt: 'Archivo 5', text: 'Texto 5' },
  { src: img2, alt: 'Archivo 6', text: 'Texto 6' },
  // ... sigue hasta tener todas las imágenes
];

const FullPhotoArchive = () => {
  return (
    <section className="fullPhotoArchive">
      <h2 className="fullPhotoArchive__title">Archivo Fotográfico Completo</h2>

      <div className="fullPhotoArchive__gallery">
        {photos.map((photo, index) => (
          <div
            className="fullPhotoArchive__item"
            key={index}
          >
            <img
              src={photo.src}
              alt={photo.alt}
              onLoad={e => {
                const height = e.target.clientHeight;
                e.target.parentElement.style.gridRowEnd = `span ${Math.ceil(height / 10)}`;
              }}
            />
            <div className="fullPhotoArchive__overlay">{photo.text}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FullPhotoArchive;
